module.exports = __webpack_public_path__ + "static/img/class_12.18310bfc.jpg";